import React from "react";
import "./DonutChartSkeleton.scss";

const DonutChartSkeleton = ({ size = 150, segments = 4 }) => {
  return (
    <div className="donut-skeleton-layout">
      <div className="legend-skeleton">
        {Array.from({ length: segments }).map((_, i) => (
          <div className="shimmer-line" key={i} />
        ))}
      </div>

      <div
        className="donut-skeleton"
        style={{
          width: size,
          height: size,
        }}
      >
        <div
          className="donut-hole"
          style={{
            width: size * 0.5,
            height: size * 0.5,
          }}
        ></div>
      </div>
    </div>
  );
};

export default DonutChartSkeleton;
